import { DEVICE, useWindowSizeChanged } from "@hooks/DeviceSize";
import MlseLogo from "@icons/MlseLogo";
import MlseLogoDesktop from "@icons/MlseLogoDesktop.svg";
import CalenderIcon from "@icons/calender.svg";
import LocationIcon from "@icons/location-icon.svg";
import CustomIconButton from "@shared-ui-components/CustomIconButton";
import { Link } from "react-router-dom";
import CustomButtom from "../DefaultLayout/CustomButtom";
import {
  DesktopLogoWrapper,
  HeaderButtonWrapper,
  StyledAppBar,
  StyledToolbar,
  StyledTypography,
} from "./styles";

interface HeaderProps {
  icon: string;
  heading: string;
  handleClick: () => void;
  showLogo?: boolean;
  showIcon?: boolean;
  handleChangeDateClick?: () => void;
  formatteddate?: string;
  handleChangeLocationClick?: () => void;
  property?: string;
}

const Header = ({
  icon,
  heading,
  handleClick,
  showLogo,
  showIcon,
  handleChangeDateClick,
  formatteddate,
  handleChangeLocationClick,
  property,
}: HeaderProps) => {
  const device = useWindowSizeChanged();
  const isDesktop = device === DEVICE.DESKTOP;

  return (
    <StyledAppBar>
      <StyledToolbar isDesktop={isDesktop}>
        <>
          {(!isDesktop || showIcon) && (
            <CustomIconButton
              handleClick={handleClick}
              icon={icon}
              ariaLabel="Menu"
            />
          )}
          {showLogo && isDesktop && (
            <DesktopLogoWrapper>
              <Link to="/">
                <img src={MlseLogoDesktop} alt="mls e logo" />
              </Link>
            </DesktopLogoWrapper>
          )}
          {showLogo && !isDesktop && (
            <Link to="/">
              <MlseLogo />
            </Link>
          )}
        </>
        <StyledTypography isDesktop={isDesktop} variant="h6">
          {heading}
        </StyledTypography>
        {showLogo && isDesktop && (
          <>
            {property && handleChangeLocationClick && (
              <HeaderButtonWrapper>
                <CustomButtom
                  value={property}
                  handleButtonClick={handleChangeLocationClick}
                  icon={LocationIcon}
                  label="home"
                  isDesktop={isDesktop}
                />
              </HeaderButtonWrapper>
            )}
            {formatteddate && handleChangeDateClick && (
              <HeaderButtonWrapper>
                <CustomButtom
                  value={formatteddate}
                  handleButtonClick={handleChangeDateClick}
                  icon={CalenderIcon}
                  label="Date"
                  isDesktop={isDesktop}
                />
              </HeaderButtonWrapper>
            )}
          </>
        )}
      </StyledToolbar>
    </StyledAppBar>
  );
};

Header.defaultProps = {
  showLogo: false,
  showIcon: false,
  handleChangeDateClick: () => null,
  formatteddate: "",
  handleChangeLocationClick: () => null,
  property: "",
};

export default Header;
